export const GUINCHO_HIDRAULICO_BAG = {
    Codigo: 9,
    Nome: 'Guincho Hidráulico Bag',
    Modelo: 'GH-1000',
    Capa: null, 
    Home: true,
    Imagens: [
        {
            Capa: true,
            Ativo: true,
            Url: "assets/IPB/Produtos/Guincho_Hidraulico_BAG/guincho_hid_bag_1.png"
        }
    ],
    Detalhes: [
        `Roda giratória 360º`,
        `Abertura dos braços regulável`,
        `Engate para transporte`,
        `Válvula de segurança`,
        `Terceiro ponto reforçado`,
        `Capacidade para 2000Kg`,
        `Movimento lateral 45 graus para os dois lados`,
        `Altura de levante 6 metros`
    ],
    Modelos: [
        { Modelo: 'GH-2000', Detalhes:	'' }
    ]
}